export default __webpack_public_path__ + "static/media/grafema_capitolio_04.7a2e25fc.jpg";